import dynamic from 'next/dynamic'
const Button = dynamic(() => import('../button'))

type Props = {
  id: string
  name: string
  type?: string
  label?: string
  labelSize?: string
  helpTextTop?: string
  helpText?: string
  errorText?: string
  errorList?: Array<string>
  autoFocus?: boolean
  placeholder?: string
  required?: boolean
  value?: string
  inlineBtnText?: string
  disabled?: boolean
  inlineBtnOnClick?: (e: React.FormEvent<HTMLInputElement>) => void
  onChange: (e: React.FormEvent<HTMLInputElement>) => void
  onBlur?: (e: React.FormEvent<HTMLInputElement>) => void
  onKeyUp?: (e: React.FormEvent<HTMLInputElement>) => void
  autoComplete?: string
  className?: string
  wrapperClassName?: string
} & typeof defaultProps

const defaultProps = {
  type: 'text',
  label: '',
  helpTextTop: '',
  helpText: '',
  errorText: '',
  errorList: [],
  placeholder: '',
  required: false,
  inlineBtnText: '',
  inlineBtnOnClick: null,
  disabled: false,
  autoComplete: '',
  className: '',
  wrapperClassName: 'my-2',
}

const Input = (props: Props): JSX.Element => {
  const labelSize = props.labelSize ? props.labelSize : 'md'

  return (
    <>
      <div className={`text-grey text-${labelSize} font-600`}>
        {props.label}
      </div>
      {props.helpTextTop && (
        <div className="text-grey text-sm leading-4 font-400">
          {props.helpTextTop}
        </div>
      )}
      <div className={`${props.wrapperClassName} flex flex-row`}>
        <input
          className={`form-input w-full ${
            props.disabled && 'bg-grey-100 text-grey-700'
          } ${props.className}`}
          id={props.id}
          autoComplete={props.autoComplete}
          name={props.name}
          type={props.type}
          placeholder={props.placeholder}
          value={props.value}
          required={props.required}
          onChange={props.onChange}
          onBlur={props.onBlur}
          onKeyUp={props.onKeyUp}
          autoFocus={props.autoFocus}
          disabled={props.disabled}
        />
        {props.inlineBtnText && (
          <>
            <div className="mr-2"></div>
            <Button
              text={props.inlineBtnText}
              disabled={false}
              onClick={props.inlineBtnOnClick}
            />
          </>
        )}
      </div>
      {props.helpText && (
        <div className="text-grey text-sm leading-4 font-400">
          {props.helpText}
        </div>
      )}
      {props.errorText && (
        <div className="text-red-200 text-sm leading-4 font-400">
          {props.errorText}
        </div>
      )}
      {props.errorList &&
        props.errorList.map((val, idx) => (
          <div
            data-testid="input-error"
            className="text-red-200 text-sm leading-4 font-400"
            key={idx}
          >
            {val}
          </div>
        ))}
    </>
  )
}

Input.defaultProps = defaultProps
export default Input
